/* Sofa Cocoon : pastilles de couleur cliquables sur les cartes produit.
   Un clic change la photo de la carte et envoie vers la fiche dans ce coloris (?variant=). Sans dépendance. */
(function () {
  'use strict';

  function $(sel, root) { return (root || document).querySelector(sel); }
  function $$(sel, root) { return Array.prototype.slice.call((root || document).querySelectorAll(sel)); }
  function closest(el, sel) { return el && el.closest ? el.closest(sel) : null; }

  document.addEventListener('click', function (e) {
    var sw = closest(e.target, '[data-pc-swatch]');
    if (!sw) return;
    e.preventDefault();
    var card = closest(sw, '.pc');
    if (!card) return;

    $$('[data-pc-swatch]', card).forEach(function (b) {
      var on = b === sw;
      b.setAttribute('aria-pressed', String(on));
      if (b.parentNode) b.parentNode.classList.toggle('is-on', on);
    });
    card.classList.add('is-picked');

    // Photo de la carte : celle du coloris choisi (si le coloris a sa propre photo).
    var src = sw.getAttribute('data-pc-img');
    var img = $('.pc-img:not(.pc-alt)', card);
    if (src && img && img.getAttribute('data-pc-cur') !== src) {
      img.setAttribute('data-pc-cur', src);
      img.classList.add('is-swapping');
      var done = function () { img.classList.remove('is-swapping'); };
      img.addEventListener('load', done, { once: true });
      window.setTimeout(done, 700);
      var set = sw.getAttribute('data-pc-srcset');
      if (set) img.setAttribute('srcset', set);
      img.setAttribute('src', src);
    }

    // Liens de la carte : la fiche s'ouvre directement dans ce coloris.
    var url = sw.getAttribute('data-pc-url');
    if (url) {
      $$('.pc-media, .pc-title a, a.btn', card).forEach(function (a) { a.setAttribute('href', url); });
    }
  });
})();
